// Per-browser conveniences. Storage can be blocked (private mode, embedded views), so every
// access is guarded and the game works without it.

export const AVATAR_COLORS = ["#8BD43A", "#3BA7E8", "#FFC83D", "#FF7A59", "#B49BFF", "#5ED3C4", "#F78FB3", "#F5A35C"];

export interface Prefs { name: string; color: string; units: "km" | "mi"; best: Record<string, number> }

const KEY = "geopin-prefs";
const legacyName = () => { try { return localStorage.getItem("geopin-name") || ""; } catch { return ""; } };

export function loadPrefs(): Prefs {
  const usLike = /^en-(US|LR|MM)$/i.test(navigator.language) || navigator.language === "en";
  const base: Prefs = { name: legacyName(), color: AVATAR_COLORS[Math.floor(Math.random() * AVATAR_COLORS.length)], units: usLike ? "mi" : "km", best: {} };
  try { return { ...base, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { return base; }
}

export function savePrefs(p: Prefs) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch { /* storage unavailable */ } }

export const prefs = loadPrefs();

export function fmtDist(km: number): string {
  if (!Number.isFinite(km) || km < 0) return "No guess";
  const v = prefs.units === "mi" ? km * 0.621371 : km;
  const u = prefs.units;
  if (v < 10) return `${v.toFixed(1)} ${u}`;
  return `${Math.round(v).toLocaleString()} ${u}`;
}

export function fmtRing(km: number): string {
  const v = prefs.units === "mi" ? km * 0.621371 : km;
  return v < 10 ? `${v.toFixed(1)}` : `${Math.round(v).toLocaleString()}`;
}
